import { EllipsisText, Headline, SimpleCell, Title } from '@vkontakte/vkui';
import { classNames } from '@vkontakte/vkjs';
import { createCompoundComponent } from '@djs/react';
import { useCheckDesktop, useVKUIPlatform } from '@dui/hooks';
import { ChatCellBaseContent } from './ChatCellBaseContent';
import { ChatCellBaseStatus } from './ChatCellBaseStatus';
import styles from './ChatCellBase.module.css';

export interface ChatCellBaseProps {
  /** Рекомендуется передавать Avatar размером 56 */
  before?: React.ReactNode;
  /** Заголовок */
  title: React.ReactNode;
  /** Бейдж справа от заголовка */
  badgeAfterTitle?: React.ReactNode;
  /**
   * Превью сообщения.
   * Рекомендуется передавать ChatCellBaseContent или ChatCellBaseStatus
   */
  subtitle?: React.ReactNode;
  /**
   * Дополнительная строка текста под children и subtitle
   */
  extraSubtitle?: React.ReactNode;
  /**
   * Индикатор статуса отправленности.
   * Рекомендуется передавать MessageBubbleIndicator (background=none)
   */
  indicator?: React.ReactNode;
  /**
   * Дополнительный контент, отображаемый справа от элемента.
   * Например, счетчик непрочитанных сообщений или статусный бейдж.
   */
  after?: React.ReactNode;
  /**
   * Выделение выбранного чата
   */
  active?: boolean;
  multiline?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  testId?: string;
  titleTestId?: string;
}

function ChatCellBaseComponent(props: ChatCellBaseProps) {
  const {
    className,
    indicator,
    onClick,
    subtitle,
    before,
    title,
    badgeAfterTitle,
    after,
    active,
    multiline,
    extraSubtitle,
    testId,
    titleTestId,
    ...restProps
  } = props;

  const platform = useVKUIPlatform();
  const isDesktop = useCheckDesktop();

  const wrapperTitle = isDesktop ? (
    <Headline data-testid={titleTestId} Component={EllipsisText}>
      {title}
    </Headline>
  ) : (
    <Title data-testid={titleTestId} level="3" Component={EllipsisText}>
      {title}
    </Title>
  );

  return (
    <SimpleCell
      className={classNames(styles.root, styles[`root__${platform}`], active && styles.root__active, className)}
      onClick={onClick}
      badgeAfterTitle={badgeAfterTitle && <div className={styles.badge}>{badgeAfterTitle}</div>}
      before={before}
      indicator={indicator}
      data-testid={testId}
      after={after}
      subtitle={subtitle}
      multiline={multiline}
      extraSubtitle={extraSubtitle}
      {...restProps}
    >
      {wrapperTitle}
    </SimpleCell>
  );
}

export const ChatCellBase = createCompoundComponent(ChatCellBaseComponent, {
  Content: ChatCellBaseContent,
  Status: ChatCellBaseStatus,
});
